var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLargeArrowRightLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1187 23.7743L17.0187 12.5743L18.5813 11.0256L29.6778 22.2221C29.6784 22.2228 29.6791 22.2234 29.6797 22.224C30.1149 22.6601 30.375 23.232 30.375 23.85C30.375 24.4688 30.1141 25.0415 29.6778 25.4778L18.5778 36.5778L17.0222 35.0221L28.1222 23.9221C28.156 23.8883 28.1685 23.8642 28.1724 23.8551C28.1734 23.8529 28.174 23.8512 28.1745 23.85C28.174 23.8487 28.1734 23.847 28.1724 23.8448C28.1685 23.8357 28.156 23.8116 28.1222 23.7778L28.1187 23.7743L28.1187 23.7743Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLargeArrowRightLight);
export default __webpack_public_path__ + "static/media/icon_large_arrow_right_light.9ba0bf54.svg";
export { ForwardRef as ReactComponent };